import useServiceFactory from "../serviceFactory";

const apiUrl = "/administracion/salidasEmpleado";

const useApiSalidasEmpleado = () => {
    const service = useServiceFactory({ uri: process.env.REACT_APP_API_URL });

    return {
        filtrar: async (params) =>
            service.get(`${apiUrl}`, { params, showLoading: true }),

        obtener: async (id) =>
            service.get(`${apiUrl}/${id}`, { showLoading: true }),

        guardar: async (params) =>
            service.post(`${apiUrl}`, params),

        actualizar: async (id, params) =>
            service.put(`${apiUrl}/${id}`, params),

        autorizar: async (id) =>
            service.put(`${apiUrl}/${id}/autorizar`),

        rechazar: async (id, params) =>
            service.put(`${apiUrl}/${id}/rechazar`, params),

        registrarSalida: async (id) =>
            service.put(`${apiUrl}/${id}/registrarSalida`)
    };
};

export default useApiSalidasEmpleado;